<!-- Breadcrumb -->
<div class="pag-container">

  <app-campaign-3-breadcrumb #breadcrumbComponent *ngIf="showBreadCrumb" [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink=""></app-campaign-3-breadcrumb>

  <!-- Bottoni gialli di lista azioni e creazione -->
  <div class="ui-g-12 d-flex justify-content-center">

    <div class="ui-g-7">
    </div>
    <div class="ui-g-5 footer-btn-container">

      <button data-testid="createNewCampaign" class="btn-page-act" (click)="onOpenCreation()">
        <i class="pi pi-plus"></i> <span>{{ 'distributionList.insert_new_list' | translate }}</span>
      </button>
    </div>
  </div>

  <div class="ui-g-12 prova">

    <!-- Attenzione il campo dei filtri della statu description manda in pasto il flag state quando in realtà dsovrebbe andarci l'idStatus (sempre nullo) -->
    <app-campaign-3-kontable *ngIf="readyTable" #distributionlist
    [columns]="[
      {
        field: 'distributionListName',
        title: 'distributionList.nome',
        filterType: textFilter
      },
      {
        field: 'distributionListDescription',
        title: 'distributionList.descrizione',
        filterType: textFilter,
        bodyTemplate: descriptionTemplate
      },
      {
        field: 'numOfClusters',
        title: 'distributionList.cluster_number',
        filterType: textFilter,
        bodyTemplate: clustersTemplate
      },
      {
        field: 'numOfActions',
        title: 'distributionList.num_promo_attive',
        filterType: textFilter,
        bodyTemplate: promoTemplate
      },
      {
        field: 'lastModifyDate',
        title: 'distributionList.last_update_date',
        type: 'date',
        filterType: dateFilter,
        bodyTemplate: lastUpdateDateTemplate
      }
    ]"
    [service]="distributionService"
    [paginationType]="paginationType"
    [additionalRowCommands]="actions"
    [expandTable]="true"
    [fetchActionListAsap]="false"
    [subjectToLoad]="pageSubject"
    [filterBySingleColumn]="false"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [fetchDistributionListDetailListAsap]="true"
    [showGlobalFilter]="true"
    [customExpandedRowTemplate]="customTemplate">

    <ng-template #customTemplate let-loadedDistributionListClusters="loadedDistributionListClusters"
      let-distributionListClusters="distributionListClusters" let-row>
      <ng-container *ngIf="loadedDistributionListClusters">
    
        <app-distribution-list-details-3 [loadedDistributionListClusters]="loadedDistributionListClusters"
          [distributionListClusters]="distributionListClusters" [fatherDistribution]="row" (refreshClusterList)="refreshClusterViaKontable(row)"></app-distribution-list-details-3>
    
      </ng-container>
    
    </ng-template>
    
    
    
    <ng-template #descriptionTemplate let-row>
      <span  class="center-number">{{row.distributionListDescription}}</span>
    </ng-template>
    
    <ng-template #clustersTemplate let-row>
      <span  class="center-number">{{row.numOfClusters}}</span>
    </ng-template>
    
    <ng-template #promoTemplate let-row>
      <span  class="center-number">{{row.numOfActions}}</span>
    </ng-template>
    
    <ng-template #lastUpdateDateTemplate let-row>
      <span  class="center-number"> {{
        row.lastModifyDate |
        date:srvCalendar.pcalendarTranslate.dateFormatFilter
        }}</span>
    </ng-template>
    
    
    <ng-template #actions let-row>
    
      <div class="d-flex justify-content-center">
        <button data-testid-generic="editDistribution" [attr.data-testid]="'editDistribution' + row.id"
          pTooltip="{{ 'common.edit' | translate }}" class="roundedButton row-buttom-margin"
          [ngClass]="{'roundedButton': !onCheckEndDistribution(row), 'disabled-button': onCheckEndDistribution(row)}"
          (click)="onOpenEdit(row)" [disabled]="onCheckEndDistribution(row)">
          <i class="pi pi-pencil icon-size"></i>
        </button>
        <button data-testid-generic="campaignActions" [attr.data-testid]="'campaignActions' + row.id"
          pTooltip="{{ 'common.actions' | translate }}" class="roundedButton" (click)="toggleMenu(row)">
          <i class="pi pi-ellipsis-h icon-size"></i>
        </button>
    
      </div>
    
      <div class="dropdown-menu" *ngIf="showMenu && row.distributionListId == currentOpenedRow">

        <button data-testid-generic="viewPromoList" [disabled]="checkAlreadyDeleted(row)"
        class="dropdown-item-creation" (click)="onViewPromoList(row)"
        [ngClass]="{'notPermitted': checkAlreadyDeleted(row)}">{{ 'distributionList.view_promo_list' | translate }}</button>
    
        <button data-testid-generic="deleteDistributionList" [disabled]="checkAlreadyDeleted(row)"
          class="dropdown-item-creation" (click)="deleteDistributionList(row)"
          [ngClass]="{'notPermitted': checkAlreadyDeleted(row)}">{{ 'common.delete' | translate }}</button>

        

      </div>
    
    
    </ng-template>
  
  </app-campaign-3-kontable>
  </div>
  
  </div>
  
  
  <p-dialog header="{{ 'campaign.confirm_delete' | translate }}" [(visible)]="displayDeleteDialog" [modal]="true"
    [closable]="false" class="custom-dialog">
  
    <div>{{ 'distributionList.confirm_delete_message' | translate }} {{ distributionListToDelete?.name }}</div>
  
    <div class="custom-footer">
      <button type="button" pButton label="{{ 'common.cancel' | translate }}" (click)="closePopupDelete()"
        icon="pi pi-times"></button>
      <button type="button" pButton label="{{ 'common.confirm' | translate }}"
        (click)="onDefinitiveDelete(distributionListToDelete)" icon="pi pi-check" style="margin-left: .25em"></button>
    </div>
  </p-dialog>
  
  
  
  
  <footer>
  
  </footer>


// WEBPACK FOOTER //
// ./src/app/views/distribution-list/distribution-list-3/distribution-list-3.component.html